import React, { useCallback, useEffect, useContext, useRef, useState } from "react";
import { useFormik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import ButtonSubmitFormikPermission from "../../../components/UI/Button/ButtonSubmitFormikPermission";
import FormAlert from "../../../components/UI/FormAlert/FormAlert";
import OverlayInfoAdicional from "../../../components/UI/Overlays/OverlayInfoAdicional";
import TextInputFormik from "../../../components/UI/TextInput/TextInputFormik";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import SelectFaseAtividade from "../../../components/UI/SelectInput/SelectFaseAtividadeFormik";
import CheckBoxFormik from "../../../components/UI/Checkbox/CheckBoxFormik";
import HtmlEditor from "../../../components/UI/HtmlEditorInput/HtmlEditor";
import SelectInput from "../../../components/UI/SelectInput/SelectInput";
import ListBoxCamposAtividadePadrao from "../../../components/UI/ListBox/ListBoxCamposAtividadePadraoFormik";
import { AuthContext } from "../../../context/AuthContext";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";

const validationSchema = Yup.object().shape({
  sequencialAtividade: Yup.string().default(""),

  sigla: Yup.string().default("").required("Informe a Sigla"),

  nome: Yup.string().default("").required("Informe o Nome da Atividade"),

  descricao: Yup.string()
    .default("")
    .max(1000, "A descrição não pode ter mais de 1000 caracteres")
    .required("Informe a Descrição"),

  tipoUsuario: Yup.string().required("Selecione o Tipo do Usuário"),

  ativo: Yup.boolean(),
  permiteAnexo: Yup.boolean(),
  documentoAssociado: Yup.boolean().default(false),
  // carimboAssinatura: Yup.boolean(),
  tipoAssinatura: Yup.boolean().when("documentoAssociado", {
    is: true,
    then: Yup.boolean().default(true),
  }),
  sequencialFase: Yup.string(),
  nomeImpressao: Yup.mixed()
    .nullable(true)
    .default("")
    .when("documentoAssociado", {
      is: true,
      then: Yup.mixed().default("").required("Informe o Nome Impressão"),
    }),
  /* tipoAssinatura: Yup.mixed().when("documentoAssociado", {
    is: true,
    then: Yup.mixed().default("N").required("Informe o Assinado Por"),
  }), */
  textoDocumento: Yup.mixed().when("documentoAssociado", {
    is: true,
    then: Yup.mixed().required("Informe o Texto do Documento"),
  }),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  switch (key) {
    case "ativo":
      initialValues[key] = true;
      break;
    case "permiteAnexo":
    case "documentoAssociado":
      initialValues[key] = false;
      break;
    case "tipoAssinatura":
      initialValues[key] = true;
      break;
    // case "tipoAssinatura":
    //   initialValues[key] = "N";
    //   break;
    default:
      initialValues[key] = "";
      break;
  }
});

const FormAtividadePadrao = ({ history, location }) => {
  const { state } = location;
  // const editorRef = React.createRef();
  const editorRef = useRef(null);
  // const [dadosInfo, setDadosInfo] = useState({})

  const { isAllowed } = useContext(AuthContext);

  const [dadosInfo, setDadosInfo] = useState({});

  const { request: submitRequest, data: submitData, errors: submitErrors, isLoading: submitIsLoading } = useApiClient();

  const handleSubmit = useCallback(
    (values) => {
      if (values.sequencialAtividade) {
        submitRequest(apiRoutes.fiscalizacao.parametrizacao.alteraAtividadePadrao, values);
      } else {
        submitRequest(apiRoutes.fiscalizacao.parametrizacao.incluiAtividadePadrao, values);
      }
    },
    [submitRequest],
  );

  // Formik
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const { values, setSubmitting, setValues } = formik;

  const handleDoubleClick = (campo) => {
    const posicaoCursor = window.getSelection().getRangeAt(0).startOffset;

    editorRef.current.editor.insertText(posicaoCursor, campo);

    editorRef.current.editor.setSelection(posicaoCursor + campo.length);
  };

  const handleChangeFormik = (descricao) => {
    formik.setFieldValue("descricaoCampo", descricao);
  };

  useEffect(() => {
    if (submitIsLoading) return;

    if (submitData || submitErrors) setSubmitting(false);

    if (submitData) {
      toast.success("Atividade salva com sucesso");
      history.push("/app/atividadePadrao");
    }
  }, [setSubmitting, submitData, submitErrors, submitIsLoading, history]);

  // Carregar item
  const {
    request: atividadePadraoRequest,
    data: atividadePadraoData,
    errors: atividadePadraoErrors,
    isLoading: atividadePadraoIsLoading,
  } = useApiClient();

  useEffect(() => {
    if (state && state.itemKey) {
      setSubmitting(true);
      atividadePadraoRequest(apiRoutes.fiscalizacao.parametrizacao.consultaAtividadePadrao, { id: state.itemKey });
      delete state.itemKey;
    }
  }, [atividadePadraoRequest, setSubmitting, state]);

  useEffect(() => {
    if (atividadePadraoIsLoading) return;

    setSubmitting(false);

    if (atividadePadraoErrors) {
      toast.error(atividadePadraoErrors.message);
    }

    if (!values.sequencialAtividade && atividadePadraoData && atividadePadraoData.result.length) {
      const info = {
        codigo: atividadePadraoData?.result[0]?.sequencialAtividade,
        data: {
          documentoInclusao: atividadePadraoData?.result[0]?.usuarioInclusao,
          nomeFormalInclusao: atividadePadraoData?.result[0]?.nomeFormalInclusao,
          nomeFormalAlteracao: atividadePadraoData?.result[0]?.nomeFormalAlteracao,
          documentoAlteracao: atividadePadraoData?.result[0]?.usuarioAlteracao,
          dataInclusao: atividadePadraoData?.result[0]?.dataInclusao,
          dataAlteracao: atividadePadraoData?.result[0]?.dataAlteracao,
        },
      };

      setDadosInfo(info);
      setValues({ ...atividadePadraoData.result[0] });
    }
  }, [
    values.sequencialAtividade,
    setValues,
    setSubmitting,
    atividadePadraoData,
    atividadePadraoErrors,
    atividadePadraoIsLoading,
  ]);

  return (
    <>
      <h1 className="h3 mb-4 text-gray-800">Atividades</h1>
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <Row>
                <Col sm="11">
                  <h6 className="m-0 font-weight-bold text-primary flex-grow-1">
                    {formik.values.sequencialAtividade ? "Alteração de Atividades" : "Nova Atividade"}
                  </h6>
                </Col>
                <Col sm="1" className="text-right">
                  <OverlayInfoAdicional data={dadosInfo} />
                </Col>
              </Row>

              {/* <Button href="#" className="btn btn-primary btn-sm btn-user">Botão</Button> */}
            </div>
            <div className="card-body">
              <FormAlert
                formik={formik}
                data={submitData}
                errors={submitErrors}
                isLoading={submitIsLoading || atividadePadraoIsLoading}
              />
              <Form noValidate onSubmit={formik.handleSubmit}>
                <fieldset
                  disabled={
                    formik.values.sequencialAtividade
                      ? !isAllowed(funcionalidades.atividadePadrao.alterar)
                      : !isAllowed(funcionalidades.atividadePadrao.inserir)
                  }
                >
                  <Row>
                    <Form.Group as={Col} sm={12} md={3}>
                      <Form.Label>Sigla</Form.Label>
                      <TextInputFormik formik={formik} field="sigla" />
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={9}>
                      <Form.Label>Nome</Form.Label>
                      <TextInputFormik formik={formik} field="nome" maxLength="100" />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} sm={12} md={12}>
                      <Form.Label>Descrição</Form.Label>
                      <TextInputFormik formik={formik} field="descricao" maxLength="240" />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} sm={6} md={6}>
                      <Form.Label>Fase</Form.Label>
                      <SelectFaseAtividade formik={formik} field="sequencialFase" />
                    </Form.Group>
                    <Form.Group as={Col} sm={6} md={6}>
                      <Form.Label>Tipo Usuário</Form.Label>
                      <SelectInput
                        formik={formik}
                        field="tipoUsuario"
                        options={[
                          { key: "", value: "", text: "" },
                          { value: "E", text: "Executor" },
                          { value: "D", text: "Diretor" },
                          { value: "A", text: "Ambos" },
                        ]}
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} sm={12} md={6}>
                      <CheckBoxFormik inline="inline" formik={formik} field="permiteAnexo" label="Permite Anexo" />
                    </Form.Group>

                    <Form.Group as={Col} sm={12} md={6}>
                      <CheckBoxFormik
                        inline="inline"
                        formik={formik}
                        field="documentoAssociado"
                        label="Documento Associado"
                      />
                    </Form.Group>
                  </Row>
                  {formik.values.documentoAssociado ? (
                    <>
                      <Row>
                        <Form.Group as={Col} sm={12} md={12}>
                          <Form.Label>Nome Impressão</Form.Label>
                          <TextInputFormik formik={formik} field="nomeImpressao" />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} sm={12} md={6}>
                          <CheckBoxFormik
                            inline="inline"
                            formik={formik}
                            field="tipoAssinatura"
                            label="Assinado Digitalmente"
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} sm={12} md={8}>
                          <Form.Label>Texto do Documento</Form.Label>
                          <HtmlEditor ref={editorRef} formik={formik} field="textoDocumento" />
                          <br />
                          <TextInputFormik formik={formik} field="descricaoCampo" />
                        </Form.Group>

                        <Form.Group as={Col} sm={12} md={4}>
                          <Form.Label>Campos Disponíveis</Form.Label>
                          <ListBoxCamposAtividadePadrao
                            formik={formik}
                            field="campos"
                            onChange={handleChangeFormik}
                            onDoubleClick={handleDoubleClick}
                          />
                        </Form.Group>
                      </Row>
                    </>
                  ) : null}
                  {formik.values.sequencialAtividade ? (
                    <Row>
                      <Form.Group as={Col} sm={12} md={3}>
                        <CheckBoxFormik formik={formik} field="ativo" label="Ativo" />
                      </Form.Group>
                    </Row>
                  ) : null}
                </fieldset>

                <Row className="mt-2">
                  <Col>
                    {formik.isSubmitting ? (
                      <TextSpinner text="Registrando atividade..." />
                    ) : (
                      <ButtonSubmitFormikPermission
                        permission={
                          formik.values.sequencialAtividade
                            ? funcionalidades.atividadePadrao.alterar
                            : funcionalidades.atividadePadrao.inserir
                        }
                        disabled={formik.isSubmitting}
                        name="Salvar"
                      >
                        Salvar
                      </ButtonSubmitFormikPermission>
                    )}
                    {"    "}
                    {!formik.isSubmitting && !formik.values.sequencialAtividade && (
                      <Button variant="light" className="mr-3" onClick={formik.handleReset}>
                        Limpar
                      </Button>
                    )}
                    {"    "}
                    {!formik.isSubmitting && (
                      <Button variant="danger" onClick={() => history.goBack()}>
                        Cancelar
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormAtividadePadrao;
